(function () {

  function getSelectedLocation() {
    const locationId = localStorage.getItem("selected_location") || null;
    let locationName = null;
    let isVersandshop = false;

    if (locationId) {
      // Versandshop hat keinen Eintrag in FW_LOCATIONS
      if (String(locationId) === String(window.FW_VERSANDSHOP_ID)) {
        locationName = "Versandshop";
        isVersandshop = true;
      } else if (window.FW && window.FW.findLocation) {
        const loc = window.FW.findLocation(locationId);
        if (loc) locationName = loc.label;
      }
    }

    // Fallback auf die App, solange sie noch laeuft
    if (!locationName && locationId && window.locationarr) {
      const match = window.locationarr.find(
        loc => loc.node.id.split('/').pop() === String(locationId)
      );
      if (match) {
        locationName = match.node.name;
        isVersandshop = locationName.toLowerCase().includes('versandshop');
      }
    }

    return { locationId, locationName, isVersandshop };
  }

  function updateSingleElement(el) {
    if (!el) return;

    const { locationId, locationName, isVersandshop } = getSelectedLocation();
    const cutline  = el.dataset.cutline || "";
    const tags     = el.dataset.tags    || "";
    const mode     = el.dataset.mode    || "full";
    const isCard   = mode === "card";

    let invData = [];
    try {
      const raw = el.dataset.inv.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
      invData = JSON.parse(raw).invLoc || [];
    } catch (e) {
      console.warn("fo-delivery: invLoc parse error", e);
    }

    const totalStock = invData.reduce((sum, e) => sum + (e.qty || 0), 0);
    let stockAtLocation = null;
    if (locationId) {
      const match = invData.find(e => String(e.loc.id) === String(locationId));
      stockAtLocation = match ? match.qty : 0;
    }

    const isSchnell      = tags.includes("F1") || tags.includes("1.4S");
    const deliveryWindow = isSchnell ? "3–5 Tagen" : "7–10 Tagen";
    const pickupWindow   = isSchnell ? "3–5 Tage" : "3–5 Tage";
    const cutlineClean   = cutline.replace(/^vsl\.\s*/i, '').trim();

    let type, label, text;

    // ── Kein Standort gewählt ──────────────────────────────
    if (!locationId) {
      el.className = "fo-delivery-status fo-delivery-status--none";
      const labelEl = el.querySelector(".fo-status-label");
      const textEl  = el.querySelector(".fo-status-text");
      if (labelEl) labelEl.textContent = "";
      if (textEl) {
        if (isCard) {
          textEl.innerHTML = '<a href="#" class="fo-location-pick" style="font-size:inherit;color:inherit;">Standort wählen</a>';
        } else {
          textEl.innerHTML = '<a href="#" class="fo-location-pick" style="font-size:inherit;color:inherit;">Kein Standort ausgewählt</a>';
        }
        textEl.style.display = "";
      }
      const badgeNone = el.querySelector(".fo-delivery-badge");
      if (badgeNone) badgeNone.style.display = "none";
      attachLocationPickerLink(el);
      return;
    }

    const badge = el.querySelector(".fo-delivery-badge");
    if (badge) badge.style.display = "";

    // ── Demnächst ──────────────────────────────────────────
    if (cutline.includes("Demnächst")) {
      type  = "soon";
      label = "Demnächst bestellbar";
      text  = isCard ? "" : "Jetzt benachrichtigen lassen, sobald verfügbar";

    // ── Vorbestellbar ──────────────────────────────────────
    } else if (cutline && cutline !== "Sofort") {
      type  = "preorder";
      label = "Vorbestellbar";
      if (isCard) {
        text = locationName ? `in ${locationName}` : "";
      } else if (isVersandshop) {
        text = `Im Zulauf - Lieferbar vsl. ${cutlineClean}`;
      } else {
        text = `Im Zulauf - Abholbereit vsl. ${cutlineClean}`;
      }

    // ── Abholshop ──────────────────────────────────────────
    } else if (!isVersandshop) {

      if (stockAtLocation > 0) {
        type  = "stock";
        label = "Auf Lager";
        text  = isCard
          ? (locationName ? `in ${locationName}` : "")
          : `Schnell abholbereit · ${pickupWindow}`;

      } else if (totalStock > 0) {
        type  = "soldout";
        label = "Nicht verfügbar";
        text  = isCard
          ? (locationName ? `in ${locationName}` : "")
          : (locationName ? `In ${locationName} vergriffen` : "Am gewählten Standort vergriffen");

      } else {
        type  = "soldout";
        label = "Leider vergriffen";
        text  = isCard ? "" : "Wir arbeiten an Nachschub";
      }

    // ── Versandshop ────────────────────────────────────────
    } else {

      if (stockAtLocation > 0) {
        type  = "stock";
        label = "Auf Lager";
        text  = isCard
          ? (locationName ? `in ${locationName}` : "")
          : `Lieferung in ${deliveryWindow} bei Dir`;

      } else {
        type  = "soldout";
        label = "Ausverkauft";
        text  = isCard ? "" : "Wir arbeiten an Nachschub";
      }
    }

    // ── DOM updaten ────────────────────────────────────────
    el.className = `fo-delivery-status fo-delivery-status--${type}`;

    const labelEl = el.querySelector(".fo-status-label");
    if (labelEl) labelEl.textContent = label;

    const textEl = el.querySelector(".fo-status-text");
    if (textEl) {
      textEl.textContent = text;
      textEl.style.display = text ? "" : "none";
    }
  }

  function attachLocationPickerLink(el) {
    const link = el.querySelector(".fo-location-pick");
    if (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const trigger = document.getElementById("fwd-trigger");
        if (trigger) {
          trigger.click();
        } else {
          document.dispatchEvent(new CustomEvent("openLocationPopup"));
        }
      });
    }
  }

  function updateAllElements() {
    document.querySelectorAll(".fo-delivery-status").forEach(updateSingleElement);
  }

  // FW_LOCATIONS steht synchron im head - kein Warten noetig
  updateAllElements();

  document.addEventListener("locationChanged", function () {
    setTimeout(updateAllElements, 50);
  });

  new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        const found = node.classList?.contains("fo-delivery-status")
          ? [node]
          : Array.from(node.querySelectorAll(".fo-delivery-status"));
        if (found.length > 0) {
          setTimeout(updateAllElements, 50);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  const stableContainer = document.querySelector('#multilocaAvailabilityContainer');
  if (stableContainer) {
    new MutationObserver(function() {
      setTimeout(updateAllElements, 800);
    }).observe(stableContainer, {
      childList: true, subtree: true
    });
  }

})();